var React = require('react');

function Graph248px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M47 31.999H1a1 1 0 0 1-1-1v-30a1 1 0 1 1 2 0v29h45a1 1 0 1 1 0 2zM41.5 8.998a3.464 3.464 0 0 1-1.764-.494l-9.086 7.497c.218.456.35.96.35 1.498 0 1.93-1.57 3.5-3.5 3.5s-3.5-1.57-3.5-3.5c0-.558.144-1.079.377-1.548l-2.31-2.34a3.453 3.453 0 0 1-1.567.388 3.47 3.47 0 0 1-1.422-.309l-6.39 5.381c.197.437.312.919.312 1.428 0 1.929-1.57 3.5-3.5 3.5S6 22.428 6 20.499s1.57-3.5 3.5-3.5c.693 0 1.336.209 1.881.558l6.169-5.193a3.463 3.463 0 0 1-.55-1.865c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5c0 .635-.183 1.223-.48 1.737l2.225 2.253a3.454 3.454 0 0 1 1.755-.49c.663 0 1.276.196 1.805.517l9.067-7.48A3.446 3.446 0 0 1 38 5.498c0-1.929 1.57-3.5 3.5-3.5s3.5 1.571 3.5 3.5c0 1.931-1.57 3.5-3.5 3.5zm-32 10.001c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5zm11-10.001c-.827 0-1.5.673-1.5 1.501 0 .827.673 1.5 1.5 1.5s1.5-.673 1.5-1.5c0-.828-.673-1.501-1.5-1.501zm7 7.001c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5zm14-12c-.827 0-1.5.673-1.5 1.499 0 .828.673 1.501 1.5 1.501S43 6.326 43 5.498c0-.826-.673-1.499-1.5-1.499z","key":1})]);
}

Graph248px.displayName = "Graph248px";

Graph248px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 48 32"};

module.exports = Graph248px;

Graph248px.default = Graph248px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/48px/graph-2-48px.svg
// module id = 1139
// module chunks = 0